import { useContext, useEffect } from "react";

import { 
    LoadSavedQuotationsCard, 
    QuotationInfoContext,
    QuotationStep,
} from "../../../shared";
import { LOADING_RENEWAL_QUOTATION_STATES } from "../../../shared/interfaces/loading-renewal-quotation-states-enum";

const {
    INIT_LOADING_RENEWAL,
} = LOADING_RENEWAL_QUOTATION_STATES;

export const LoadRenewalQuotation = () => {
    const { 
        setRenewalQuotationState,
    } = useContext(QuotationInfoContext);


    useEffect(() => {        
        setRenewalQuotationState(INIT_LOADING_RENEWAL);
        /* eslint-disable-next-line */
    }, []);

    return <LoadSavedQuotationsCard />;
};
